// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    
    getInvoicesByClient as getInvoicesByClientAPI,
    
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { invoicesApiResponseError, invoicesApiResponseSuccess } from './actions';
import { InvoicesActionTypes } from './constants';

// const api = new APICore();

function* listInvoicesByClient({payload:{contactoId}}) {
    try {
        const response = yield call(getInvoicesByClientAPI,contactoId);
        const listaInvoices = response.data.data;
        yield put(invoicesApiResponseSuccess(InvoicesActionTypes.LIST_INVOICES_BY_CLIENT, listaInvoices));
    } catch (error) {
        yield put(invoicesApiResponseError(InvoicesActionTypes.LIST_INVOICES_BY_CLIENT, error));
    }
}

export function* watchListInvoicesByClient(): any {
    yield takeEvery(InvoicesActionTypes.LIST_INVOICES_BY_CLIENT, listInvoicesByClient);
}

function* invoicesSaga(): any {
    yield all([
        fork(watchListInvoicesByClient),
    ]);
}

export default invoicesSaga;
